import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServiceBase } from '../utilty/ServiceBase';
import { ContestAttemptAnswerDto, ContestAttemptDto } from '../models/contest-attempt-dto';

@Injectable({
  providedIn: 'root'
})
export class ContestAttemptService extends ServiceBase  {

    private http = inject(HttpClient);

  /**
   * POST /api/ContestAttempt/StartContestAttempt?contestId=123
   * Controller: StartContestAttemptAsync(int contestId)
   */
  startContestAttempt(contestId: number): Observable<ContestAttemptDto> {
    const params = new HttpParams().set('contestId', String(contestId));
    return this.http.post<ContestAttemptDto>(
      `${this.baseUrl }/ContestAttempt/StartContestAttempt`,
      {},                       // empty body since contestId is a query param
      { params }
    );
  }

  /**
   * POST /api/ContestAttempt/SaveContestAttemptAnswer
   * Body: ContestAttemptAnswerDto
   * Returns: boolean
   */
  saveContestAttemptAnswer(dto: ContestAttemptAnswerDto): Observable<boolean> {
    // Ensure createdAtUtc is an ISO string if you build it on the client.
    // dto.createdAtUtc = dto.createdAtUtc ?? new Date().toISOString();

    return this.http.post<boolean>(
      `${this.baseUrl }/ContestAttempt/SaveContestAttemptAnswer`,
      dto
    );
  }
}

